__turbopack_context__.v({
  "container": "ArticlesRelated-module__Uis24a__container",
  "fadeInItems": "ArticlesRelated-module__Uis24a__fadeInItems",
  "img": "ArticlesRelated-module__Uis24a__img",
  "imgWrap": "ArticlesRelated-module__Uis24a__imgWrap",
  "project": "ArticlesRelated-module__Uis24a__project",
  "spacing--lg": "ArticlesRelated-module__Uis24a__spacing--lg",
  "spacing--md": "ArticlesRelated-module__Uis24a__spacing--md",
  "spacing--sm": "ArticlesRelated-module__Uis24a__spacing--sm",
  "spacing--xl": "ArticlesRelated-module__Uis24a__spacing--xl",
  "spacing--xs": "ArticlesRelated-module__Uis24a__spacing--xs",
  "spacing--xxl": "ArticlesRelated-module__Uis24a__spacing--xxl",
  "spacing--xxs": "ArticlesRelated-module__Uis24a__spacing--xxs",
  "spacing--xxxl": "ArticlesRelated-module__Uis24a__spacing--xxxl",
  "spacing--xxxs": "ArticlesRelated-module__Uis24a__spacing--xxxs",
  "subtitle": "ArticlesRelated-module__Uis24a__subtitle",
  "title": "ArticlesRelated-module__Uis24a__title",
  "wrapper": "ArticlesRelated-module__Uis24a__wrapper",
});
